import { jsxs as e, jsx as l } from "react/jsx-runtime";
import { getIconStyles as o } from "../styles.js";
const r = (C) => /* @__PURE__ */ e(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: o(C),
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.7421 0.96967C11.035 0.676777 11.5099 0.676777 11.8028 0.96967L14.8028 3.96967C15.0957 4.26256 15.0957 4.73744 14.8028 5.03033L11.8028 8.03033C11.5099 8.32322 11.035 8.32322 10.7421 8.03033C10.4492 7.73744 10.4492 7.26256 10.7421 6.96967L13.2118 4.5L10.7421 2.03033C10.4492 1.73744 10.4492 1.26256 10.7421 0.96967Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M20.9309 12.0024C21.3438 11.969 21.7056 12.2766 21.739 12.6895C21.7605 12.955 21.7725 13.2281 21.7725 13.4996C21.7734 14.3219 21.67 15.141 21.4647 15.9372C21.3613 16.3383 20.9524 16.5796 20.5513 16.4763C20.1502 16.3729 19.9088 15.9639 20.0122 15.5628C20.1858 14.8893 20.2733 14.1964 20.2725 13.5009C20.2725 13.2725 20.2624 13.0389 20.2439 12.8105C20.2105 12.3977 20.5181 12.0359 20.9309 12.0024Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M18.4336 7.14113C18.7505 6.87444 19.2236 6.91518 19.4903 7.23213C20.0199 7.86146 20.4674 8.55548 20.8221 9.29753C21.0008 9.67123 20.8426 10.119 20.4689 10.2977C20.0952 10.4763 19.6475 10.3182 19.4688 9.94448C19.1688 9.31696 18.7904 8.73007 18.3426 8.19788C18.0759 7.88093 18.1166 7.40781 18.4336 7.14113Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M19.3786 18.7392C19.6949 19.0065 19.7347 19.4797 19.4673 19.7961C19.2935 20.0017 19.11 20.2011 18.9168 20.3943C18.3358 20.9764 17.6839 21.482 16.9756 21.8999C16.6189 22.1104 16.159 21.9919 15.9485 21.6352C15.738 21.2784 15.8566 20.8186 16.2133 20.6081C16.8124 20.2546 17.3642 19.8265 17.8556 19.3342C18.0198 19.17 18.1754 19.0009 18.3216 18.8279C18.589 18.5115 19.0622 18.4718 19.3786 18.7392Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.0225 5.25C9.83442 5.25 7.736 6.11919 6.18883 7.66637C4.64165 9.21354 3.77246 11.312 3.77246 13.5C3.77246 15.688 4.64165 17.7865 6.18883 19.3336C7.73601 20.8808 9.83442 21.75 12.0225 21.75C12.2508 21.75 12.4836 21.7399 12.7119 21.7214C13.1248 21.688 13.4866 21.9956 13.52 22.4085C13.5534 22.8213 13.2459 23.1831 12.833 23.2166C12.5673 23.2381 12.2941 23.25 12.0225 23.25C9.4366 23.25 6.95665 22.2228 5.12817 20.3943C3.29969 18.5658 2.27246 16.0859 2.27246 13.5C2.27246 10.9141 3.29969 8.43419 5.12817 6.60571C6.95665 4.77723 9.4366 3.75 12.0225 3.75H14.2725C14.6867 3.75 15.0225 4.08579 15.0225 4.5C15.0225 4.91421 14.6867 5.25 14.2725 5.25H12.0225Z",
          fill: "currentColor"
        }
      )
    ]
  }
);
export {
  r as RotateIcon
};
//# sourceMappingURL=RotateIcon.js.map
